<script lang="ts">
export default { name: 'PinValidate' };
</script>

<script setup lang="ts">
// COMPONENTS
import { GInputCode } from '@flash-global66/g-input-code';
import { GButton } from '@flash-global66/g-button';
import GIconFont from '@flash-global66/g-icon-font';
import { GImage } from '@flash-global66/g-image';

// COMPOSABLES
import { useRouter } from 'vue-router';
import { usePinValidate } from './usePinValidate';

// TYPES
import type { PinEmits } from '../../types/pin.type';

const emits = defineEmits<PinEmits>();

const router = useRouter();

const {
  FIELDS,
  pinFlow,
  forgotPinText,
  inputCodeRef,
  onClose,
  onChange,
  onComplete,
  onReset,
  handleForgotPin,
} = usePinValidate(emits, router);
</script>

<template>
  <div
    data-test="pin:validate"
    class="flex flex-col bg-gray-10 w-full h-full py-12 relative"
  >
    <div
      @click="onClose"
      data-test="button:close"
      class="absolute top-28 right-12 cursor-pointer flex justify-center items-center"
    >
      <GIconFont name="light times" class="text-8" />
    </div>

    <div class="flex flex-col justify-center items-center flex-grow">
      <GImage name="lock" size="lg" class="mb-md" />

      <section class="text-center">
        <h4 class="text-8 text-blue-14 font-semibold">
          {{ pinFlow.title.value ? pinFlow.title.value : 'Ingresa tu PIN' }}
        </h4>
        <h5 class="text-blue-12 mt-4">
          {{
            pinFlow.description.value
              ? pinFlow.description.value
              : 'Debemos validar tu PIN para continuar.'
          }}
        </h5>
      </section>
      <section class="mt-4 px-2">
        <g-input-code
          password
          :fields="FIELDS"
          :text-error="pinFlow.error.value"
          @change="onChange"
          @complete="onComplete"
          ref="inputCodeRef"
        />
      </section>
      <section class="mt-8" v-if="pinFlow.fromSignIn.value">
        <a
          @click="handleForgotPin"
          class="text-center text-sm cursor-pointer text-gray-4"
          >{{ forgotPinText }}</a
        >
      </section>
    </div>

    <section
      class="flex flex-col items-center gap-md max-w-lg mx-auto w-full px-6 md:flex-row md:justify-center"
    >
      <g-button
        v-if="!pinFlow.fromSignIn.value"
        class="w-52 md:order-1"
        variant="tertiary"
        data-test="button:reset"
        @click="onReset"
      >
        ¿Olvidaste tu PIN?
      </g-button>
    </section>
  </div>
</template>
